"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _immutable = require("immutable");

var _constants = require("settings-ui-sdk/SiteSettings/constants");

var _actions = require("settings-ui-sdk/SiteSettings/actions");

var _routeSelectors = require("../selectors/routeSelectors");

var _UrlPathParams = require("settings-ui-sdk/constants/UrlPathParams");

var _SiteSettings = _interopRequireDefault(require("settings-ui-sdk/SiteSettings/SiteSettings"));

var _StagedObject = _interopRequireDefault(require("redux-less/StagedObject"));

var _PropertyTypes = _interopRequireDefault(require("redux-less/constants/PropertyTypes"));

var _getAllDomainsOrDomainNameFromURL = _interopRequireDefault(require("../utils/getAllDomainsOrDomainNameFromURL"));

var properties = [{
  type: _PropertyTypes.default.SIMPLE,
  key: _constants.ALL_DOMAINS_OR_DOMAIN_NAME,
  defaultValue: ''
}, _constants.FAVICON_SRC, _constants.LOGO_ALT, _constants.LOGO_HEIGHT, _constants.LOGO_SRC, _constants.LOGO_WIDTH, _constants.FOOTER_HTML, _constants.HEAD_HTML, _constants.INCLUDE_PRIMARY_CSS, _constants.COMPANY_DOMAIN, _constants.COMPANY_NAME, _constants.JQUERY_VERSION, _constants.INCLUDE_JQUERY, _constants.INCLUDE_JQUERY_MIGRATE, _constants.INCLUDE_JQUERY_IN_FOOTER, _constants.FILE_HOSTING_DOMAIN, _constants.HSTS_DURATION, _constants.HSTS_PRELOAD, _constants.HSTS_INCLUDE_SUBDOMAINS, {
  type: _PropertyTypes.default.NESTED,
  key: _constants.JS_INTEGRATIONS,
  children: [{
    type: _PropertyTypes.default.NESTED,
    key: _constants.AD_ROLL,
    children: [_constants.AD_ID, _constants.ENABLED, _constants.PIXEL_ID]
  }, {
    type: _PropertyTypes.default.NESTED,
    key: _constants.GOOGLE_ANALYTICS,
    children: [_constants.ENABLED, _constants.TRACKING_ID]
  }, {
    type: _PropertyTypes.default.NESTED,
    key: _constants.DRIFT,
    children: [_constants.ENABLED, _constants.BODY_END_HTML]
  }]
}, _constants.ROBOTS_TXT, _constants.CANONICAL_URL_PAGES, _constants.CANONICAL_URL_BLOG_LISTING, _constants.CONTENT_SEARCH_RESULTS_PAGE_PATH, _constants.CONTENT_SEARCH_RESULTS_TEMPLATE_PATH, _constants.CUSTOM_404, _constants.CUSTOM_500, _constants.CUSTOM_PASSWORD_TEMPLATE_PATH];
var UpdateSiteSettings = new _StagedObject.default({
  stagedSelector: function stagedSelector(state) {
    return state.modules.website.pages.staging.updateSiteSettings;
  },
  domainSelector: _routeSelectors.getSiteSettingsFromRoute,
  requestSuccessActionType: _actions.FetchSiteSettingsActionTypes.SUCCESS,
  requestSuccessDataSelector: function requestSuccessDataSelector(payload) {
    var allDomainsOrDomainName = (0, _getAllDomainsOrDomainNameFromURL.default)(window.location.href);

    if (allDomainsOrDomainName && allDomainsOrDomainName !== _UrlPathParams.ALL_DOMAINS) {
      var overrideByDomain = payload.data[_constants.BODY_OVERRIDE_BY_DOMAIN][allDomainsOrDomainName];

      if (overrideByDomain) {
        var domainSiteSettings = (0, _immutable.fromJS)(payload.data).merge(overrideByDomain).toJS();
        return new _SiteSettings.default((0, _extends2.default)({
          allDomainsOrDomainName: allDomainsOrDomainName
        }, domainSiteSettings));
      }
    }

    return new _SiteSettings.default((0, _extends2.default)({
      ALL_DOMAINS: _UrlPathParams.ALL_DOMAINS
    }, payload.data));
  },
  namespace: _UrlPathParams.PAGES,
  objectType: _UrlPathParams.PAGES + "/SiteSettings",
  properties: properties
});
var _default = UpdateSiteSettings;
exports.default = _default;
module.exports = exports.default;